import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRoutingModule } from './admin-routing.module';
import { AllUsersListComponent } from './All-Users/all-users-list/all-users-list.component';
import { UserEditComponent } from './All-Users/user-edit/user-edit.component';
import { UserViewComponent } from './All-Users/user-view/user-view.component';
import { UsersAddComponent } from './All-Users/users-add/users-add.component';
import { UsersEditComponent } from './users/users-edit/users-edit.component';
import { UsersListComponent } from './users/users-list/users-list.component';
import { UsersViewComponent } from './users/users-view/users-view.component';
import { AgmCoreModule } from '@agm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { ChartistModule } from 'ng-chartist';
import { NgxMaskModule } from 'ngx-mask';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TopicContentComponent } from './topic-content/topic-content.component';
import { StudentPlacementReportsComponent } from './All-Users/student-placement-reports/student-placement-reports.component';
import { StudentPipelinesListComponent } from './student-pipelines/student-pipelines-list/student-pipelines-list.component';
import { StudentPipelineAddComponent } from './student-pipelines/student-pipeline-add/student-pipeline-add.component';
import { StudentPipelinesMatchingResultsComponent } from './student-pipelines/student-pipelines-matching-results/student-pipelines-matching-results.component';
import { DynamicDetailComponent } from './dynamic-detail/dynamic-detail.component';
import { QuillModule } from 'ngx-quill';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';
import { PasswordModalComponent } from './course/password-modal/password-modal.component';
import { RouterModule } from '@angular/router';
import { ClientPipelinesListComponent } from './client-pipelines/client-pipelines-list/client-pipelines-list.component';
import { ClientPipelineAddComponent } from './client-pipelines/client-pipeline-add/client-pipeline-add.component';
import { ClientPipelinesMatchingResultsComponent } from './client-pipelines/client-pipelines-matching-results/client-pipelines-matching-results.component';


@NgModule({
  declarations: [
    UsersListComponent,
    UsersViewComponent,
    UsersEditComponent,
    AllUsersListComponent,
    UsersAddComponent,
    UserEditComponent,
    UserViewComponent,
    TopicContentComponent,
    StudentPlacementReportsComponent,
    StudentPipelinesListComponent,
    StudentPipelineAddComponent,
    StudentPipelinesMatchingResultsComponent,
    ClientPipelinesListComponent,
    ClientPipelineAddComponent,
    ClientPipelinesMatchingResultsComponent,
    DynamicDetailComponent,    
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ChartistModule,
    AgmCoreModule,
    NgSelectModule,
    NgbModule,
    SwiperModule,
    PipeModule,
    NgxDatatableModule,    
    NgxMaskModule.forRoot(),
    RouterModule,
    MatMenuModule,
    MatSlideToggleModule,
    NgxSpinnerModule,
    QuillModule.forRoot(),
  ],
  providers : [NgbActiveModal,PermissionGuard],
  entryComponents: [PasswordModalComponent]
})
export class AdminModule { }
